// DS: PO56
import React, { useContext, useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { getCurrentAdSafety } from '../../Ads/redux/selectors';
import { useSelector } from 'react-redux';
import { getIsDuperbrowseActive } from '../../Duperbrowse/redux/selectors';
import s from './LocalizedCookieBanner.scss';
const LocalizedCookieBanner = ({ onAccept })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const bannerRef = useRef(null);
    const { adsEnabled } = useContext(SessionContext);
    const adSafety = useSelector((state)=>getCurrentAdSafety(state));
    const isDuperbrowse = useSelector((state)=>getIsDuperbrowseActive(state));
    const { requiresNonEuGdpr } = useContext(SessionContext);
    // We don't wait for ads so we have to work around them, this checks if we will load an anchor
    // unit and moves the banner above it
    useEffect(()=>{
        if (typeof window === 'undefined') {
            return;
        }
        if (window['__ADUNITS__'] && Array.isArray(window['__ADUNITS__']) && window['__ADUNITS__'].length > 0 && adsEnabled && adSafety !== 'off') {
            const found = window['__ADUNITS__'].find((v)=>/anchor/i.test(v));
            if (found && bannerRef.current) {
                bannerRef.current.style.bottom = isMobile ? '100px' : '90px';
            }
        }
        if ((!adsEnabled || adSafety === 'off') && bannerRef.current) {
            bannerRef.current.style.bottom = '0px';
        }
    }, [
        isMobile,
        adsEnabled,
        adSafety
    ]);
    if (!requiresNonEuGdpr || isDuperbrowse) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.LIGHT
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        ref: bannerRef
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['container']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['details']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "popup.localizedcookiebanner.details"
    }, "Please know that cookies are required to operate and", /*#__PURE__*/ React.createElement("a", {
        href: URLS.TOS
    }, " enhance our services"), " as well as for", ' ', /*#__PURE__*/ React.createElement("a", {
        href: URLS.PRIVACY
    }, "advertising purposes"), ". We value your privacy. If you are not comfortable with us using this information, please", ' ', /*#__PURE__*/ React.createElement("a", {
        href: URLS.COOKIES
    }, "review your settings"), " before continuing your visit.")), /*#__PURE__*/ React.createElement("div", {
        className: s['buttons']
    }, /*#__PURE__*/ React.createElement(GhostButton, {
        variant: 'main',
        size: 'medium',
        href: URLS.COOKIES,
        className: s['button']
    }, t('popup.localizedcookiebanner.learn_more')), /*#__PURE__*/ React.createElement(SolidButton, {
        variant: 'approval-green',
        size: "medium",
        onClick: onAccept,
        className: s['button']
    }, t('popup.localizedcookiebanner.close'))))));
};
LocalizedCookieBanner.displayName = 'LocalizedCookieBanner';
export default LocalizedCookieBanner;
